module.exports = __webpack_public_path__ + "media/instagram-reels.8a0540ae.mp4";